#import "../fragments/inbox-thread-fragment.graphql"

query GetInboxThread($threadId: ID!) {
    inboxThread(id: $threadId) {
        ...InboxThreadFragment
    }
}
